import React from "react";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import { IconButton, TableRow, TableCell, Tooltip, Box, Typography } from "@mui/material";
import { Edit, Reorder, CheckCircle, Cancel } from "@mui/icons-material";

const SortableItem = ({ value, widths }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: value.promo_banner_id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    background: isDragging ? '#f5f5f5' : undefined,
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      hover
      key={"banner-" + value.promo_banner_id}
      sx={{
        '&:hover': { backgroundColor: '#f5f5f5' },
      }}
    >
      {/* Banner Image */}
      <TableCell sx={{ width: widths.col1, p: 2 }}>
        {value.promo_banner_url && <img src={value.promo_banner_url} alt="" style={{ width: "100%", borderRadius: 4 }} />}
      </TableCell>
      {/* Banner Icon */}
      <TableCell sx={{ width: widths.colIcon, p: 2 }} align="center">
        <Box
          sx={{
            width: 40,
            height: 40,
            p: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#364152',
            borderRadius: 1,
            mx: 'auto',
          }}
        >
          {value.promo_banner_icon && value.promo_banner_icon.trim() !== '' ? (
            <img src={value.promo_banner_icon} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          ) : null}
        </Box>
      </TableCell>
      {/* Title and Description */}
      <TableCell sx={{ width: widths.col2, p: 2 }}>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {value.promo_banner_title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {value.promo_banner_text}
        </Typography>
      </TableCell>
      {/* Actions: Edit, Status, Drag */}
      <TableCell sx={{ width: widths.col0, p: 2 }} align="right">
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <Tooltip title="Edit">
            <IconButton component={Link} to={`/banners/edit/${value.promo_banner_id}`} color="info">
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title={value.promo_banner_is_active === 1 ? 'Active' : 'Not Active'}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              {value.promo_banner_is_active === 1 ? (
                <CheckCircle sx={{ color: 'green', fontSize: 24 }} />
              ) : (
                <Cancel sx={{ color: 'red', fontSize: 24 }} />
              )}
            </Box>
          </Tooltip>
          <IconButton
            {...listeners}
            {...attributes}
            size="small"
            sx={{ cursor: 'grab', ml: 1, '&:active': { cursor: 'grabbing' } }}
            title="Drag to reorder"
          >
            <Reorder />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  );
};

const SortablePromoBanners = ({ items, widths }) => {
  return (
    <SortableContext items={items.map((item) => item.promo_banner_id)}>
      <tbody>
        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}`}
            value={value}
            widths={widths}
          />
        ))}
      </tbody>
    </SortableContext>
  );
};

export default SortablePromoBanners;